// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Text } from '@mantine/core';
import { FC } from 'react';
import { ContactGroup } from '../../Types/AuthT';
import { ThemeText } from '../../Atoms/ThemeText';
import ContactGroupActions from './ContactGroupActions';

interface Props {
  label: string;
  groups: ContactGroup[];
  closeNavbar: () => void;
}

const ContactGroupsList: FC<Props> = ({ label, groups, closeNavbar }) => {
  const mapGroupItemUI = (group: ContactGroup) => {
    const { name } = group;
    return (
      <Group
        p={5}
        position="apart"
        sx={{
          height: 32,
        }}
      >
        <Text
          className="overflow-ellipsis"
          ml="lg"
          sx={(theme) => ({ color: theme.colorScheme === 'dark' ? 'white' : 'black', maxWidth: 160 })}
        >
          {name}
        </Text>
        <ContactGroupActions group={group} closeNavbar={closeNavbar} />
      </Group>
    );
  };

  return (
    <>
      <ThemeText p="md" size="sm" variant="text" weight="bolder">
        {label}
      </ThemeText>
      {groups.length === 0 && (
        <Text ml="sm" italic color="dimmed" size="xs" weight="lighter">
          Keine Gruppen angelegt.
        </Text>
      )}
      {groups.map(mapGroupItemUI)}
    </>
  );
};

export default ContactGroupsList;
